export interface IExpertSystemElements {
    donorAbo: string,
    recipientAbo: string,
    bmtMm: number,
    recipientCpra: string,
    recipientDialysisStatus: string,
    isInSwap: boolean,
    isAboCompatible: boolean
}
